import React, { Component } from 'react';
import {postData} from '../services/api';
import store from '../store/main';
import {Button} from '@material-ui/core';
class Buttons extends Component{

    postUserText() {
        store.messages.push({
            text: this.props.name
        });
        
        postData({
            text: this.props.name,
            id: store.sessionId,
            language: localStorage.getItem('language')
        })

    }
    
    render(){
        return (
                <Button variant="outlined" className="side" onClick={() => this.postUserText()} >
                    {this.props.name}
                </Button>
        )
    }
}

export default Buttons;